import type { TenantImportRow } from '@einwert/valuation-api-client'

export function rowFieldErrors(row: TenantImportRow): Record<string, string> {
    return Object.fromEntries(row.validation_issues.flatMap((issue) => (issue.field ? [[issue.field, issue.message]] : [])))
}

export function rowErrors(row: TenantImportRow): string[] {
    return [...new Set([...(row.blocking_reason ? [row.blocking_reason] : []), ...row.validation_issues.map((issue) => issue.message)])]
}
